import { DocketItemStatus } from '@oolio-group/domain';
import config from '../../config';
import { makeRequest } from '../fetchHelper';
import { autoBumpAttemptGuard } from './autoBump';

// Single entry point for every auto-bump call site: filters, marks, sends, then releases only the failed ids.
export async function submitAutoBumpBatch(
  eligibleIds: string[],
  status: DocketItemStatus,
): Promise<void> {
  const idsToSubmit = autoBumpAttemptGuard.filterUnattempted(eligibleIds);
  if (!idsToSubmit.length) return;

  autoBumpAttemptGuard.markAttempted(idsToSubmit);
  try {
    const response = await makeRequest(
      config.KDS_SERVICE_URI + '/docket/bump',
      { ids: idsToSubmit, status },
    );
    if (!Array.isArray(response)) {
      autoBumpAttemptGuard.release(idsToSubmit);
      return;
    }
    // /docket/bump only lists successfully-bumped dockets, so anything missing here genuinely failed.
    const succeededIds = new Set(
      response.map((docket: { id?: string }) => docket?.id),
    );
    autoBumpAttemptGuard.release(
      idsToSubmit.filter(id => !succeededIds.has(id)),
    );
  } catch (error) {
    autoBumpAttemptGuard.release(idsToSubmit);
    console.error('Auto-bump failed for dockets', idsToSubmit, error);
  }
}
